module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "content-wrapper"
  }, [_vm._m(0), _vm._v(" "), _c('section', {
    staticClass: "content"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-4"
  }, [_c('div', {
    staticClass: "box box-info"
  }, [_vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "box-body"
  }, [_c('div', [_c('form', {
    staticClass: "form-horizontal"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-sm-2 control-label",
    attrs: {
      "for": "nickname"
    }
  }, [_vm._v("Nick")]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-10"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.nickname),
      expression: "nickname"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "id": "nickname",
      "placeholder": "Nickname"
    },
    domProps: {
      "value": (_vm.nickname)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.nickname = $event.target.value
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-sm-2 control-label",
    attrs: {
      "for": "ip-address"
    }
  }, [_vm._v("IP")]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-10"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model.trim",
      value: (_vm.ip),
      expression: "ip",
      modifiers: {
        "trim": true
      }
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "id": "ip-address",
      "placeholder": "IP address"
    },
    domProps: {
      "value": (_vm.ip)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.ip = $event.target.value.trim()
      },
      "blur": function($event) {
        _vm.$forceUpdate()
      }
    }
  })])]), _vm._v(" "), _vm._m(2), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-sm-2 control-label",
    attrs: {
      "for": "type"
    }
  }, [_vm._v("Ban type")]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-10"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.type),
      expression: "type"
    }],
    staticClass: "form-control",
    attrs: {
      "id": "type"
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.type = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, [_c('option', {
    attrs: {
      "value": "1"
    }
  }, [_vm._v("Game - preusmerava na stranu ban")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "2"
    }
  }, [_vm._v("Chat - gasi mu chat")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "3"
    }
  }, [_vm._v("Skins - zabrana dodavanja")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "4"
    }
  }, [_vm._v("Igra - ubija tab (oprezno)")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "5"
    }
  }, [_vm._v("Salje mu poruku iz 'Reasona'")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "6"
    }
  }, [_vm._v("Protrese mu ekran svakih 20 sek. Unban da ne trese stalno.")])])])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-sm-2 control-label",
    attrs: {
      "for": "reason"
    }
  }, [_vm._v("Reason")]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-10"
  }, [_c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.reason),
      expression: "reason"
    }],
    staticClass: "form-control",
    attrs: {
      "id": "reason",
      "rows": "2"
    },
    domProps: {
      "value": (_vm.reason)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.reason = $event.target.value
      }
    }
  })])])])])]), _vm._v(" "), _c('div', {
    staticClass: "box-footer"
  }, [_c('div', [_c('p', {
    staticClass: "text-danger text-right"
  }, [_vm._v(_vm._s(_vm.msg))]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-info pull-right",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.ban()
      }
    }
  }, [_vm._v("\n                Ban\n              ")])])])])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-8"
  }, [_c('table', {
    staticClass: "table table-condensed table-striped"
  }, [_vm._m(3), _vm._v(" "), (_vm.bannedList.length > 0) ? _c('tbody', _vm._l((_vm.bannedList), function(ban) {
    return _c('tr', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (_vm.current_date < ban.date_to),
        expression: "current_date < ban.date_to"
      }]
    }, [_c('td', [_vm._v(_vm._s(decodeURI(ban.nickname)))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.calcType(ban.type)))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(ban.reason))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(ban.date_from))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(ban.date_to))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(ban.ip))]), _vm._v(" "), _c('td', [_c('button', {
      staticClass: "btn btn-danger",
      on: {
        "click": function($event) {
          _vm.unban(ban.id)
        }
      }
    }, [_vm._v("Unban")])])])
  })) : _c('tbody', [_c('div', {
    staticClass: "ui hidden divider"
  }), _vm._v(" "), _c('h3', [_vm._v("\n            List is empty\n          ")]), _vm._v(" "), _c('div', {
    staticClass: "ui hidden divider"
  })])]), _vm._v(" "), _vm._m(4)])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "content-header"
  }, [_c('h1', [_vm._v("\n      Ban by IP\n      "), _c('small', [_vm._v("Here you can ban users")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "box-header with-border"
  }, [_c('h3', {
    staticClass: "box-title"
  }, [_vm._v("Ban user")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-sm-2 control-label",
    attrs: {
      "for": "datetimepicker"
    }
  }, [_vm._v("Date to")]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-10"
  }, [_c('input', {
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "id": "datetimepicker"
    }
  })])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', [_c('tr', [_c('th', [_vm._v("Nick")]), _vm._v(" "), _c('th', [_vm._v("Type")]), _vm._v(" "), _c('th', [_vm._v("Reason")]), _vm._v(" "), _c('th', [_vm._v("Date")]), _vm._v(" "), _c('th', [_vm._v("Expire")]), _vm._v(" "), _c('th', [_vm._v("IP")]), _vm._v(" "), _c('th', [_vm._v("Action")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('p', [_vm._v("Ukoliko unbanujes nekog, posalji mu link: "), _c('a', {
    attrs: {
      "href": "https://agar.rs/unba.html"
    }
  }, [_vm._v("http://agar.rs/unba.html")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-868e0d3e!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/modules/ban/Index.vue
// module id = 319
// module chunks = 2